import React from "react";
import { Contacts } from "./Contacts";
import { CreateAccount } from "./CreateAccount";
export const ContactUs = ({ contacts, createAccountValues }) => (React.createElement("div", { className: "contact-us-root" },
    React.createElement(Contacts, { ...contacts }),
    React.createElement(CreateAccount, { ...createAccountValues })));
